import React from 'react';
import EvaluationForm from '../components/evaluation/EvaluationForm';

const EvaluationFormPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-12rem)]">
      <EvaluationForm />
    </div>
  );
};

export default EvaluationFormPage;
